module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcthigh4-f28a67f83a665c0d1d552c7a5f26c01d.jpg";